import CustomZObject from './CustomZObject.js';

export default class CirklonObject extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        zobject.setAttribute("primary-color", "#cdcdcd");
        zobject.setAttribute("secondary-color", "#b4b4b4");
    }
}
